import { render, staticRenderFns } from "./LandingPagesAll.vue?vue&type=template&id=2f31024c&"
import script from "./LandingPagesAll.vue?vue&type=script&lang=js&"
export * from "./LandingPagesAll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports